// extracted by mini-css-extract-plugin
export var dropdownIcon = "_kw-6";
export var imgContainer = "_kw-3";
export var menuIcon = "_kw-5";
export var pillWrapper = "_kw-2";
export var pillsContainer = "_kw-1";
export var subscriptionCard = "_kw-0";
export var subscriptionLogo = "_kw-4";